import { CSSProperties } from 'react';
import { ICreateThemeData } from 'src/types';
import getTextColor from '../../../hooks/getTextColorContrast';

const DEFAULT_PRIMARY_COLOR = '#096846';
const DEFAULT_CHAT_COLOR = '#FF6F98';

export interface ThemeColors {
  primary: string;
  chatPrimary: string;
}

export const getThemeColors = (themeData?: ICreateThemeData): ThemeColors => ({
  primary: themeData?.primary || DEFAULT_PRIMARY_COLOR,
  chatPrimary: themeData?.['chat-primary'] || DEFAULT_CHAT_COLOR,
});

export const getButtonStyle = (themeData?: ICreateThemeData, useChat = false): CSSProperties => {
  const colors = getThemeColors(themeData);
  const backgroundColor = useChat ? colors.chatPrimary : colors.primary;

  return {
    backgroundColor,
    color: getTextColor(backgroundColor),
  };
};

export const getToggleButtonStyle = (
  isActive: boolean,
  themeData?: ICreateThemeData,
): CSSProperties => {
  const colors = getThemeColors(themeData);

  return {
    backgroundColor: isActive ? colors.chatPrimary : colors.primary,
  };
};

export const commonButtonClasses =
  'flex items-center justify-center gap-2 px-5 py-2 text-white rounded-full disabled:opacity-70 transition-all duration-200 ease-in-out';

export const compactButtonClasses =
  'flex whitespace-nowrap items-center w-full justify-center gap-2 px-2.5 py-2 text-white rounded-full disabled:opacity-70 transition-all duration-200 ease-in-out';
